import type { Field, FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import type { DynamicFieldFormula } from '@jira/polaris__domain-field/src/DynamicFieldFormula.types.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateFieldFormula =
	(fieldKey: FieldKey, formula: DynamicFieldFormula, abortSignal?: AbortSignal) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote, createAnalyticsEvent }: Props,
	): Promise<Field> => {
		const state = getState();
		const currentField = state.fields[fieldKey];

		fireTrackAnalytics(createAnalyticsEvent({}), 'issueFields updated', {
			updatedItems: [{ name: 'formula' }],
			issueFieldKey: currentField.key,
			issueFieldType: currentField.type,
		});

		const oldConfiguration = currentField.formula
			? {
					polarisFormula: currentField.formula,
				}
			: {};

		const configuration = { polarisFormula: formula };

		await fieldRemote.updateFieldConfiguration(
			{
				fieldKey,
				oldConfiguration,
				configuration,
				type: 'updateFieldFormula',
			},
			abortSignal,
		);

		const newField = {
			...currentField,
			formula,
			configuration: {
				...currentField.configuration,
				...configuration,
			},
		};
		setState({
			fields: {
				...getState().fields,
				[fieldKey]: newField,
			},
		});

		return newField;
	};
